/*
  src/redux/session/reducer.js

  Created by erikchristensen on 11/03/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from '../update';

import {
  IMPERSONATION_CEASED,
  TOKEN_INVALIDATED as IMPERSONATION_TOKEN_INVALIDATED
} from '../impersonate/constants';

import {
  ACTIVE_USER_LOADED,
  IMPERSONATED_USER_LOADED
} from '../entities/constants';

import {
  TOKEN_INVALIDATED as AUTH_TOKEN_INVALIDATED
} from '../auth/constants';

const initialState = {
  activeUserId:null,
  impersonatedUserId:null,
  isImpersonating:false
};

export default function(state=initialState,action){
  switch(action.type){
  case ACTIVE_USER_LOADED:
    return update(state,{
      $merge:{
        activeUserId:action.payload.instance.id
      }
    });

  case AUTH_TOKEN_INVALIDATED:
    return update(state,{
      $merge:{
        activeUserId:null
      }
    });


  case IMPERSONATION_TOKEN_INVALIDATED:
    return update(state,{
      $merge:{
        impersonatedUserId:null,
        isImpersonating:false
      }
    });


  case IMPERSONATED_USER_LOADED:
    return update(state,{
      $merge:{
        impersonatedUserId:action.payload.instance.id,
        isImpersonating:true
      }
    });

  case IMPERSONATION_CEASED:
    return update(state,{
      $merge:{
        impersonatedUserId:null,
        isImpersonating:false
      }
    });

  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/session/reducer.js